import { ReactNode } from 'react';
import clsx from 'clsx';

export interface PillProps {
  children: ReactNode | ReactNode[];
  classes?: string;
}

export function Pill({ children, classes }: PillProps) {
  return (
    <span
      className={clsx(
        'rounded-full mx-0.5 inline-flex items-center py-1 px-2 text-sm leading-4 bg-gray-200 dark:bg-gray-700',
        classes
      )}
    >
      <span>{children}</span>
    </span>
  );
}
